/**
 * Specific selectors
 */
const selectPluginList = (state) => state.getIn(['workspacePlugins', 'plugins']);
const selectPluginDetails = (state, pluginId) => state.getIn(['workspacePlugins', 'pluginDetails', pluginId]);
const selectPluginCreateStatus = (state) => state.getIn(['workspacePlugins', 'creatingPlugin']);

const selectPluginVersionList = (state, pluginId) => (
  state.getIn(['workspacePlugins', 'pluginVersions', pluginId])
);

export {
  selectPluginList,
  selectPluginVersionList,
  selectPluginDetails,
  selectPluginCreateStatus,
};
